import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../../service/nav.service';
import { BlogDataService } from '@shared/service/blog-data.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public menuItems: Menu[];
  public openSide = false;
  public activeItem = 'home';
  public active = false;
  public activeChildItem = '';
  public overlay = false;

  constructor(
    public navServices: NavService,
    public blogDataService: BlogDataService,
    private router: Router) { }

  ngOnInit() {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
    });
  }

  toggleSidebar() {
    this.openSide = !this.openSide;
  }

  closeOverlay() {
    this.openSide = false;
  }

  // For Active Main menu in Mobile View
  setActive(menuItem) {
    if (this.activeItem === menuItem) {
      this.activeItem = '';
    } else {
      this.activeItem = menuItem;
    }

  }

  isActive(item) {
    return this.activeItem === item;
  }

  // For Active Child Menu in Mobile View
  setChildActive(subMenu) {
    if (this.activeChildItem === subMenu) {
      this.activeChildItem = '';
    } else {
      this.activeChildItem = subMenu;
    }
    this.toggleSidebar();
  }

  ischildActive(subMenu) {
    return this.activeChildItem === subMenu;
  }

  setGalleryData(category: string) {
    this.blogDataService.setSelectedCategory(category);
    this.toggleSidebar();
    this.router.navigate(['/gallery']);
  }

  extTabLinkClicked(menuItem) {
    if (menuItem.category && menuItem.category === 'all') {
      this.blogDataService.setSelectedCategory('all');
      this.router.navigate([menuItem.path]);
    }

    this.toggleSidebar();
    this.router.navigate([menuItem.path]);
  }

}
